import React, { useState, useEffect } from "react";

const Carousel = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch("https://kvrstarlightmedicalacademy.com/api/slides.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const prevSlide = () => {
    setCurrentIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  };
  const nextSlide = () => {
    setCurrentIndex((i) => (i === images.length - 1 ? 0 : i + 1));
  };
  const images = [];
  data?.map((element) => {
    images.push(element.filename);
  });
  return (
    <div
      style={{
        width: "100%",
        padding: "15px",
        position: "relative",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "100%", // set your desired display size
          height: "400px",
          margin: "0 auto",
          overflow: "hidden",
          borderRadius: "10px",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="img-responsive">
                <img
                  src={`assets/slides/${images[currentIndex]}`}
                  alt={`Slide ${currentIndex + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    className: "img-responsive",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prevSlide}
        style={{ position: "absolute", top: "50%", left: "35px" }}
      >
        ◀
      </button>
      <button
        onClick={nextSlide}
        style={{ position: "absolute", top: "50%", right: "35px" }}
      >
        ▶
      </button>
    </div>
  );
};

export default Carousel;
